<template lang="pug">
.extraFields
  template(v-for="group in extraFieldGroups")
    v-row
      v-col(cols="auto")
        h5.primaryHover--text {{ $camelToString($displayName(group.label)) || $camelToString($displayName(group.name)) }}
      v-col
        h6.text--text {{ group.description }}
    v-row(:key="key")
      v-col(v-for="field in $sortByUISequence(group.fields)", cols="3")
        foo-field(
          :entity="group",
          :field="field",
          :label="field.label || field.name",
          :type="$isFieldList(field, group) ? 'list' : field.type",
          :value="getValue(field)",
          @change="input($event === null ? false : $event, field)",
          @input="input($event, field)",
          :inputValue="getValue(field)"
          :checked="getValue(field) === true",
          :disabled="field.disabled || disabled",
          :items="$getFieldOptions(field, group)",
          :errorMessages="errorInstance[errorHash + '.' + $displayName(group.name) + '.' + field.name]",
        )
</template>

<script>
import EntityMixin from '@/mixins';

function genId() {
  return Math.random().toString(36).slice(2)
}

export default {
  mixins: [EntityMixin],
  props: ['entity', 'path', 'disabled'],
  data() {
    return {
      key: genId(),
    }
  },
  watch: {
    disabled: {
      handler() {
        this.key = genId()
      }
    }
  },
  methods: {
    getValue(field) {
      if (!field.extra) return this.instance[this.$lcfirst(field.name)]
      return this.getExtraData(null, field, this.instance.extraData || []).value
    },
    getExtraData($event, field, extraData) {
      return extraData.find(e => Number(e.extraFieldId) === Number(field.extraFieldId)) || { type: field.type, value: $event, extraFieldId: field.extraFieldId }
    },
    input ($event, field) {
      let fieldCopy = { ...field };
      fieldCopy.name = this.$lcfirst(fieldCopy.name)
      if (!fieldCopy.extra)
        this.$store.commit(this.setInstancePathAction, { path: this.path + '.' + fieldCopy.name, value: $event })
      else
        this.inputExtra($event, fieldCopy);
    },
    inputExtra ($event, field) {
      var extraData = this.instance.extraData ? [...this.instance.extraData] : [];
      var data = this.getExtraData($event, field, extraData)
      data.value = $event
      data.entityState = data.id ? 3 : 4
      data.fieldName = field.name
      data.labelName = field.label
      if (data.uid === undefined && !data.new) {
        data.new = true
        extraData.push(data)
      }
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.extraData', value: extraData });
    },
  },
  computed: {
    extraFieldGroups() {
      return _.get(this.entity, 'fields', []).filter(f => f.extra);
    },
    errors() {
      return this.$store.state.errors;
    },
    modalErrors() {
      return this.$store.state.modalErrors;
    },
    errorInstance() {
      return this.modalInstance && !_.isEmpty(this.modalErrors) ? this.modalErrors : this.errors;
    },
    errorHash() {
      if(this.isExtraFieldGroup) return this.extraLabelHash;
      return this.path ? this.path : this.$lcfirst(this.entity.name);
    },
    isExtraFieldGroup() {
      return Boolean(_.get(this.entity, 'extra'));
    },
    extraLabelHash() {
      return this.$displayName(_.get(this.relation, 'name', _.get(this.entity, 'name')));
    },
  },
}
</script>
